<template>
  <div class="layout-container">
    <div class="top-container">
      <Header class="top-header"></Header>
    </div>
    <main :style="{'min-height': minHeight + 'px'}">
      <div class="main-breadcrumb">
        <div class="main-width">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: item.path }" v-for="(item, index) in breadcrumbList" :key="index">{{item.title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <!-- 内容展示部分 -->
      <div class="main-container">
        <router-view />
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import { contentFinds } from "@/api/common/content";

import Header from "@/components/common/header";

import Footer from "@/components/common/footer";
export default {
  name: "Home",
  components: { Header, Footer },
  data() {
    return {
      minHeight: 100,
      breadcrumbList: []
    };
  },
  created() {
    this.getWindowHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowHeight);
  },
  watch: {
    $route: {
      handler() {
        this.initBreadcrumb();
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.getWindowHeight);
    this.initBreadcrumb();
  },
  methods: {
    getWindowHeight() {
      this.minHeight = window.innerHeight - 300 - 230;
    },

    // 获取面包屑列表
    initBreadcrumb() {
      
      let matched = this.$route.matched;
      let breadcrumbList = [];
      matched.forEach(item => {
        if (item?.meta?.breadcrumb) {
          breadcrumbList = [...breadcrumbList, ...item.meta.breadcrumb];
        } else {
          let obj = {
            path: item.path,
            title: item?.meta?.title
          }
          breadcrumbList.push(obj);
        }
      })
      this.breadcrumbList = breadcrumbList;
      console.log(this.breadcrumbList,'坤坤');

    },

    // 请求数据
    getData(params) {
      let data = Object.assign({}, this.pageParams, this.contentBean, params || {});
      return new Promise(async (resolve, reject) => {
        const res = await contentFinds(data);
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.layout-container {
  .top-container {
    position: relative;
    width: 100%;
    height: 230px;
    background: url("../../assets/images/main_top_banner.png") no-repeat;
    background-size: cover;
    background-position: top;
    .top-header {
      position: absolute;
    }
  }
  .main-breadcrumb {
    padding: 24px 0;
    .el-breadcrumb {
      font-size: 16px;
    }
  }
  .main-container {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 768px) {
  .layout-container {
    .top-container {
      height: auto;
      aspect-ratio: 5/2;
    }
    .main-breadcrumb {
      padding: 20px 14px;
      .el-breadcrumb {
        font-size: 14px;
      }
    }
    .main-container {
      padding: 0 14px;
      margin-bottom: 24px;
    }
  }
}
</style>
